import LinkIcon from "../assets/icons/linkIcon";
import { openNotification } from "../components/notification";

export async function shareLink(link: string, title: string, text: string, x: number = 0, y: number = 0) {
  console.log(x, y);
    if (navigator.share) {
      try {
        await navigator
          .share({
            url: link,
            title: title,
            text: text
          });
      } catch (error) {
        copyToClipboard(link);
        openNotification(<><LinkIcon/>Link copied to clipboard</>);
        setTimeout(() => {
              openNotification(<><LinkIcon/>fasdf</>, {x: 100, y: 100});
            }, 1000);
      }
    } else {
        copyToClipboard(link);
        setTimeout(() => {
        openNotification(<><LinkIcon/>Link copied to clipboard</>, {x: x, y: y});
          }, 1000);
    }
}

export function copyToClipboard(text: string) {
    navigator.clipboard.writeText(text).catch(err => {
        console.error("Failed to copy text: ", err);
    });
}